'use client';

import cx from 'classix';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { FaFlag } from 'react-icons/fa6';

import ListingReportModal from '@/features/listing/components/listing-report-modal/listing-report-modal';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import { type User } from '@/features/user/types/user-types';
import { useRouter } from '@/i18n/routing';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';

// import styles
//   from '@/features/listing/components/listing-detailed/listings-detail-actions/listings-detail-actions.module.scss';
import styles from './user-report.module.scss';

interface UserReportProps {
  userId: User['id'];
}

export default function UserReport(props: UserReportProps) {
  const { userId } = props;

  const router = useRouter();

  const actionsTranslation = useTranslations('global.actions');

  const [isReportModalShow,
    setIsReportModalShow] = useState<boolean>(false);

  const handleReportModalClose = () => {
    setIsReportModalShow(false);
  };

  const handleShowReportModal = () => {
    const loggedUser = getUserBearerCookie();

    // TODO: [auth-redirect]

    if (loggedUser) {
      setIsReportModalShow(true);
    } else {
      router.push(ROUTER_LINKS.phoneAuth);
    }
  };

  return (
    <>
      <button
        className={cx(
          styles.userReport_action,
          styles.userReport_action__isMobile,
        )}
        aria-label="report"
        onClick={handleShowReportModal}
      >
        <div className={styles.userReport_actionInner}>
          <FaFlag
            className={styles.userReport_actionIcon}
          />

          <p className={styles.userReport_text}>{actionsTranslation('report')}</p>
        </div>
      </button>

      {isReportModalShow && (
        <ListingReportModal
          userId={userId}
          isActive={isReportModalShow}
          onClose={handleReportModalClose}
        />
      )}
    </>
  );
}
